import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { bool, func, number, object, objectOf } from 'prop-types';
import Icon from 'yoda-core-components/lib/components/Icon';
import YdtFilter from 'yoda-core-components/lib/assets/svg/YdtFilter.svg';
import YdtSort from 'yoda-core-components/lib/assets/svg/YdtSort.svg';
import classNames from 'classnames/bind';
import { getLocaleString } from 'yoda-site-components/lib/components/Pricing/PricingHelper';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import GallerySliderConnected from '../GallerySlider/GallerySlider';
import StoreFilterCategoryConnected from '../StoreFilterCategory/StoreFilterCategory';
import FloatingFilterButtonConnected from '../FloatingFilterButton/FloatingFilterButton';
import SortBy from '../SortBy/SortBy';
import * as sliderActions from '../../actions/SliderActions';
import * as styles from './FilterHeader.css';
import selectNoSearchResults from '../../selectors/NoSearchResults';
import { selectLastAction, selectDisablePrevNoResultsMessage } from '../../selectors/fromState';
import { prevNoResultsMessage } from '../../common/constants';
import { getURLParameterBykey, goUrl, removeQueryStringParameter, updateUrl } from '../../utils';

const cx = classNames.bind(styles);

const btnStyles = dt([
    'font-open-sans-semibold',
    'sm:text-normal',
    'lg:text-small',
    'inline-flex',
    'items-center',
    'justify-center',
    'w-full',
    'h-full',
]);

/* istanbul ignore next */
export class FilterHeader extends PureComponent {
    static defaultProps = {
        countOfSearchResults: 0,
        countOfSelectedFilters: 0,
        prevResults: {},
        router: {
            location: {
                search: '',
            },
        },
        renderBrPreviewSkeletonGrid: false,
        enableStickyFilter: false,
    };

    static propTypes = {
        actions: objectOf(func).isRequired,
        disablePrevNoResultsMessage: bool.isRequired,
        countOfSearchResults: number,
        countOfSelectedFilters: number,
        noResults: bool.isRequired,
        prevResults: object,
        router: object,
        renderBrPreviewSkeletonGrid: bool,
        enableStickyFilter: bool,
    };

    constructor(props) {
        super(props);
        this.state = { isOrientationChange: false };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        const {
            actions: { showSlider },
            router: { location },
            router: {
                location: { search },
            },
        } = this.props;
        let urlStatus;

        if (location) {
            urlStatus = getURLParameterBykey('filters', search);
        }
        if (urlStatus && urlStatus.indexOf('open') !== -1) {
            showSlider();
            goUrl(removeQueryStringParameter(undefined, 'filters'), true);
        }
    }

    componentDidMount() {
        this.handleOrientationChange();
        window.addEventListener('orientationchange', () => this.handleOrientationChange());
    }

    componentWillUnmount() {
        window.removeEventListener('orientationchange', () => this.handleOrientationChange());
    }

    handleOrientationChange = () => {
        const setOriention = Math.abs(window?.orientation) === 90;
        this.setState({
            isOrientationChange: setOriention,
        });
    };

    sortChangeCB = (e) => {
        updateUrl(e, null, null, {});
    };

    searchResultCount = () => {
        const { noResults, countOfSearchResults } = this.props;

        const gTitleClasses = `${dt([
            'font-open-sans-regular',
            'sm:mt-4',
            'md:mt-6',
            'text-black',
            'lg:text-medium',
            'smMd:text-center',
            'sm:text-sm',
            'smOnly:py-0',
            'smOnly:pl-0',
            'smOnly:pr-1',
            'smOnly:mx-1',
            'smOnly:mb-0',
            'whitespace-nowrap',
        ])} ${cx('gTitle')}`;

        if (!noResults && countOfSearchResults) {
            return (
                <div className={gTitleClasses}>
                    {getLocaleString(countOfSearchResults)}
                    {countOfSearchResults > 1 ? ' Results' : ' Result'}
                </div>
            );
        }
        return null;
    };

    filterBtn = () => {
        const {
            actions: { toggleSlider },
            countOfSelectedFilters,
            renderBrPreviewSkeletonGrid,
        } = this.props;
        const skeletonStyles = renderBrPreviewSkeletonGrid
            ? dt(['rounded-lg', 'text-gray-15'])
            : '';
        return (
            <button
                type="button"
                onClick={!renderBrPreviewSkeletonGrid ? toggleSlider : undefined}
                className={`${btnStyles} ${skeletonStyles}`}
                data-automation-id="product-filter-button"
            >
                <span className={dt(['mr-2'])}>
                    <Icon
                        automationId="filter-icon"
                        className="icon"
                        height="24"
                        viewBox="0 0 40 40"
                        width="24"
                    >
                        <YdtFilter />
                    </Icon>
                </span>
                Filter
                {countOfSelectedFilters > 0 && (
                    <span className={dt(['ml-1'])}>{` (${countOfSelectedFilters})`}</span>
                )}
            </button>
        );
    };

    sortBtn = () => {
        const { renderBrPreviewSkeletonGrid } = this.props;
        const skeletonStyles = renderBrPreviewSkeletonGrid
            ? dt(['rounded-lg', 'text-gray-15'])
            : '';
        return (
            <>
                <div className={`${btnStyles} ${dt(['absolute'])} ${skeletonStyles}`}>
                    <Icon className={dt(['mr-1'])} height="24" width="24">
                        <YdtSort />
                    </Icon>
                    Sort
                </div>
                {!renderBrPreviewSkeletonGrid ? <SortBy /> : null}
            </>
        );
    };

    renderPrevNoResultsMessageSection = () => {
        const {
            prevResults: { prevNoResults = false },
            disablePrevNoResultsMessage,
        } = this.props;

        let prevNoResultsMessageSection = null;

        if (prevNoResults && !disablePrevNoResultsMessage) {
            prevNoResultsMessageSection = (
                <div className={cx('gallerySearchInfoMsgBlock')}>
                    <MessageBox
                        automationId="noResultsInfoMsg"
                        hasClose={false}
                        level="section"
                        showMessage
                        title={prevNoResultsMessage}
                        type="information"
                    />
                </div>
            );
        }

        return prevNoResultsMessageSection;
    };

    renderMobile = () => {
        const {
            actions: { toggleSlider },
            countOfSelectedFilters,
            renderBrPreviewSkeletonGrid,
            enableStickyFilter,
        } = this.props;
        const wrapperClasses = dt(['sm:mb-4', 'md:mb-6', 'lg:hidden']);
        const secondaryWrapperClasses = dt([
            'font-open-sans-bold',
            'text-black',
            'text-small',
            'sm:flex',
            'sm:flex-col',
            'md:block',
        ]);
        const mobileFilterClasses = countOfSelectedFilters > 0 && dt(['smOnly:!px-0']);
        const gridViewClasses = `${dt([
            'flex-1',
            'sm:mb-4',
            'md:mb-6',
            'flex',
            'text-center',
            'gap-x-4',
        ])} ${cx('gridView', mobileFilterClasses)}`;

        const gridItemClasses = `${dt([
            'inline-block',
            'text-center',
            'w-1/2',
            'border',
            'border-solid',
            'border-gray-40',
            'rounded-lg',
            'h-10',
            'flex',
            'justify-center',
            'items-center',
        ])} ${cx('gridItem')}`;
        const StoreFilterCategoryClasses = dt(['smOnly:mt-1', 'md:my-2']);
        const sortBtnClasses = `${gridItemClasses} ${dt([
            'relative',
            renderBrPreviewSkeletonGrid ? '!border-gray-15' : 'border-gray-60',
            renderBrPreviewSkeletonGrid ? 'bg-light-white' : '',
        ])}`;

        return (
            <div className={wrapperClasses} data-component-name="FilterHeader">
                {this.renderPrevNoResultsMessageSection()}
                <div className={secondaryWrapperClasses}>
                    <div className={gridViewClasses}>
                        <div className={sortBtnClasses}>{this.filterBtn()}</div>
                        <div className={sortBtnClasses}>{this.sortBtn()}</div>
                    </div>
                </div>
                {!renderBrPreviewSkeletonGrid ? (
                    <>
                        <StoreFilterCategoryConnected
                            customWrapperClasses={StoreFilterCategoryClasses}
                            hideCurbsidePickupLabel
                            parentSection="filterheader"
                        />
                        {this.searchResultCount()}
                        <GallerySliderConnected />
                        {enableStickyFilter ? (
                            <FloatingFilterButtonConnected onClick={toggleSlider} />
                        ) : (
                            <></>
                        )}
                    </>
                ) : null}
            </div>
        );
    };

    render() {
        const { renderMobile } = this;

        return renderMobile();
    }
}

const mapStateToProps = (store) => ({
    countOfSearchResults: store.countOfSearchResults,
    countOfSelectedFilters: store.countOfSelectedFilters,
    deviceType: store.context ? store.context.deviceType : {},
    disablePrevNoResultsMessage: selectDisablePrevNoResultsMessage(store),
    noResults: selectNoSearchResults(store),
    prevResults: selectLastAction(store),
    enableStickyFilter: get(store, 'context.featureFlags.enableStickyFilter', false),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(sliderActions, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterHeader));
